export const ITERATION_TYPES = ['A', 'M', 'S'] as const;

export const COMMS_TYPES = ['I', 'R'] as const;
